import { ManagePerpetualsComponent } from './manage-perpetuals.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManagePerpetualsRoutingModule } from './manage-perpetuals-routing.module';
import { ManagePerpetualsProgramtypesComponent } from './manage-perpetuals-programtypes/manage-perpetuals-programtypes.component';
import { ManageService } from '../services/manage.service';
import { NgProgressModule } from 'ngx-progressbar';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ManagePerpetualsRoutingModule,
    NgProgressModule,
    NgxPaginationModule,
    FormsModule,
    SharedModule
  ],
  declarations: [
    ManagePerpetualsProgramtypesComponent,
    ManagePerpetualsComponent
  ],
  providers: [ManageService]
})
export class ManagePerpetualsModule { }
